import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutContactQuickInfo extends Layout {
    buttonExpandDetail: Button;
    panelOrderTypeQuickInfo: Panel;
    sourceContact: DataSource;
    textboxEmail: Textbox;
    textboxName: Textbox;
    textboxPhone: Textbox;
}
